import React from 'react';
import { formatDateTime } from '../../utils/dateUtils';

const RecentAlerts = ({ alerts }) => {
    const getStatusColor = (status) => {
        switch (status) {
            case 'accepted':
                return { dot: 'bg-green-500', badge: 'bg-green-100 text-green-700' };
            case 'rejected':
                return { dot: 'bg-red-500', badge: 'bg-red-100 text-red-700' };
            case 'expired':
                return { dot: 'bg-gray-500', badge: 'bg-gray-100 text-gray-700' };
            default:
                return { dot: 'bg-orange-500', badge: 'bg-orange-500 text-white' };
        }
    };

    return (
        <div className="bg-white rounded-xl bxshadow mrgall border bxshadowh">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Recent Alerts</h2>
            <div className="space-y-3">
                {alerts.slice(0, 5).map((alert) => {
                    const colors = getStatusColor(alert.response_status);
                    return (
                        <div key={alert.id} className="flex items-center justify-between p-2 border-red-100 bg-white rounded-md">
                            <div className="flex items-center gap-3">
                                <div className={`w-2 h-2 rounded-full bg-red-500 ${colors.dot}`} />
                                <div>
                                    <p className="text-sm font-medium text-red-500">Vendor #{alert.vendor_id}</p>
                                    <p className="text-xs text-red-300">
                                        {formatDateTime(alert.sent_at)}
                                    </p>
                                </div>
                            </div>
                            <span className={`text-xs px-2 py-2 capitalize rounded-md bg-red-100 text-red-700 ${colors.badge}`}>
                                {alert.response_status}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RecentAlerts;